/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-2",
    "aws_cognito_identity_pool_id": "eu-west-2:28e66505-2a1e-47dd-adf8-ac5a63cce6e5",
    "aws_cognito_region": "eu-west-2",
    "aws_user_pools_id": "eu-west-2_u0DGpvPkt",
    "aws_user_pools_web_client_id": "1n3bvhuq9mf5gerogerdkuq0v4",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [],
    "aws_content_delivery_bucket": "cmdashboardapp-20210704200245-hostingbucket-staging",
    "aws_content_delivery_bucket_region": "eu-west-2",
    "aws_content_delivery_url": "https://d1ug018p3x4478.cloudfront.net"
};


export default awsmobile;
